var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BaseContainer, HeaderLogo, LogoContainer, IconContainer, ContentContainer, } from "./styles";
import Icon from "../../elements/Icon";
import Logo123 from "/images/logo-123-horizontal.png";
import { useLocation } from "react-router-dom";
import { getHost123milhasUrl } from "../../../utils/host123milhasUrl";
export var TopHeader = function () {
    var location = useLocation();
    var hideBackButtonPaths = [
        "/senha/resetar/",
        "/senha/resetar/sucesso",
        "/email/sucesso/",
    ];
    var hideBackButton = hideBackButtonPaths.some(function (path) {
        return location.pathname.includes(path);
    });
    return (_jsx(BaseContainer, { children: _jsxs(ContentContainer, { children: [!hideBackButton && (_jsx(IconContainer, __assign({ onClick: function () { return history.back(); } }, { children: _jsx(Icon, { name: "outlined-arrow-forward" }) }))), _jsx(HeaderLogo, __assign({ href: getHost123milhasUrl() || "https://123milhas.com" }, { children: _jsx(LogoContainer, { src: Logo123, alt: "Logo 123 Milhas" }) }))] }) }));
};
